import { ReactElement, useMemo, useCallback } from 'react';
import { Stack, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { useFormikContext } from 'formik';

import { replaceParamsPath } from '~utils/router';
import { PATHS } from '~constants/paths';

import { SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME } from '../../../utils/scheduleRouteForm';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../Context';
import { getFormByTemplateInitialValues } from '../../utils';

import { AssistantGenerateRoutesDialogByTemplateContentActionsContainer } from './styles';

const AssistantGenerateRoutesDialogByTemplateContentActions =
  (): ReactElement => {
    const navigate = useNavigate();

    const {
      onClose,
      activeTab: { tab: currentTab },
      data: {
        templates,
        selectedTemplate: { value: selectedTemplate },
      },
      stepper: {
        currentApiTransactionId: { value: currentApiTransactionId },
        currentRoutes: { value: currentRoutes },
        isSuccesCompleted: { value: isSuccesCompleted },
      },
    } = useAssistantGenerateRoutesDialogByTemplateContext();

    const { values, submitForm, isSubmitting } =
      useFormikContext<ReturnType<typeof getFormByTemplateInitialValues>>();

    const isTabForm = useMemo(() => currentTab === 'form', [currentTab]);

    const isScheduleRouteEnabled = useMemo(
      () => values[SCHEDULE_ROUTE_BASE_FORM_FIELDS_NAME.SCHEDULE_ROUTE_ENABLED],
      [values],
    );

    const hasTemplates = useMemo(
      () => templates.length > 0,
      [templates.length],
    );

    const handleRedirectRouteDetails = useCallback(() => {
      if (currentApiTransactionId) {
        const urlRedirect = replaceParamsPath(PATHS.ROUTES.VEHICLE_PLANNING, {
          ':apiTransactionId': currentApiTransactionId,
          ':routeId': currentRoutes[0].routeId,
        });

        navigate(urlRedirect);
      }
    }, [currentApiTransactionId, currentRoutes, navigate]);

    const handleRedirectRoutesList = useCallback(() => {
      navigate(PATHS.ROUTES.BASE);
    }, [navigate]);

    return (
      <AssistantGenerateRoutesDialogByTemplateContentActionsContainer>
        <Stack flex={1}>
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <Button color="secondary" onClick={onClose}>
              Cerrar
            </Button>

            {isTabForm && hasTemplates && Boolean(selectedTemplate) && (
              <Stack direction="row" spacing={2}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={submitForm}
                  loading={isSubmitting}
                >
                  Generar
                </LoadingButton>
              </Stack>
            )}

            {!isTabForm && isSuccesCompleted && (
              <Stack direction="row" spacing={2}>
                {!isScheduleRouteEnabled && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleRedirectRouteDetails}
                  >
                    Ver ruta
                  </Button>
                )}

                {isScheduleRouteEnabled && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleRedirectRoutesList}
                  >
                    Ver listado de rutas
                  </Button>
                )}
              </Stack>
            )}
          </Stack>
        </Stack>
      </AssistantGenerateRoutesDialogByTemplateContentActionsContainer>
    );
  };

export default AssistantGenerateRoutesDialogByTemplateContentActions;
